<template>
    <div style="height: 100%;width: 100%;overflow:auto;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-tabs type="border-card" v-model="active" @tab-click="handleClick">
            <el-tab-pane label="资料">
                <el-descriptions class="margin-top" :column="2" size="mini" border>
                    <el-descriptions-item>
                        <template slot="label">
                          入米兰会员
                        </template>
                        {{mldate}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                          首次到美容部
                        </template>
                        {{beautydate}}
                    </el-descriptions-item>
                </el-descriptions>
                <el-divider>疗程剩余情况</el-divider>
                <el-descriptions class="margin-top" :column="2" border size="mini">
                    <el-descriptions-item v-for="(item,key) in cardCourses" :key="key">
                        <template slot="label">
                          {{item.projectname}}
                        </template>
                        {{item.restnumber}}
                    </el-descriptions-item>
                </el-descriptions>
                <el-divider>客户基本资料</el-divider>
                <el-descriptions class="margin-top" :column="2" border size="mini" direction="vertical">
                    <el-descriptions-item  label="姓名">{{memberInfo.membername}}</el-descriptions-item>
                    <el-descriptions-item  label="昵称">
                        <el-input placeholder="请输入内容" v-model="memberInfo.nickname" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="性别"><span v-if="memberInfo.sex==1">男</span><span v-else>女</span></el-descriptions-item>
                    <el-descriptions-item label="职业">
                        <el-input placeholder="请输入内容" v-model="memberInfo.pos" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="出生日期">
                        <el-date-picker  v-model="memberInfo.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="mini" style="width: 100%;" @change="updateMemberInfo"></el-date-picker>
                    </el-descriptions-item>
                    <el-descriptions-item label="年龄">
                        {{memberInfo.age}}
                    </el-descriptions-item>
                    <el-descriptions-item label="年收入">
                        <el-input type="number" placeholder="请输入内容" v-model="memberInfo.duty" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    
                </el-descriptions>
                <el-descriptions :column="1" direction="vertical" border size="mini">
                    <!--<el-descriptions-item label="来的方式">
                        <el-radio-group v-model="memberInfo.beautysource" @change="updateMemberInfo">
                            <el-radio :label="item.constantid" v-for="(item,key) in membersources" :key="key">{{item.constantname}}</el-radio>
                        </el-radio-group>
                        <el-input placeholder="请输入内容" v-model="memberInfo.beautysource" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>-->
                    <el-descriptions-item label="家庭住址" >
                        <el-input placeholder="请输入内容" v-model="memberInfo.address" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                </el-descriptions>

                <el-divider>客户家庭成员</el-divider>
                <el-descriptions class="margin-top" :column="1" border size="mini" direction="vertical">
                    <el-descriptions-item label="婚姻:婚否,夫妻感情如何,老公是做什么的等等">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" placeholder="请输入内容" v-model="memberInfo.partner" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="小孩:年龄,性别,学校,谁带,小孩让他的困扰等等">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" placeholder="请输入内容" v-model="memberInfo.child" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="父母:(父母是做什么),其他关联的人等等">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" placeholder="请输入内容" v-model="memberInfo.father" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                </el-descriptions>
                <el-form label-position="top" :model="memberInfo">
                    <el-form-item label="客户的辉煌事迹,人生履历">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="memberInfo.lifeexperience" @change="updateMemberInfo"></el-input>
                    </el-form-item>
                    <el-form-item label="来米兰之前在哪里做养生">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="memberInfo.spaexperience" @change="updateMemberInfo"></el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="问题">
                <el-form label-position="top" :model="custheadinfo" class="pfzk">
                    <el-form-item>
                        染发周期
                        <el-select v-model="custheadinfo.rfzq" size="mini" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-bottom: 10px;">
                        烫发周期
                        <el-select v-model="custheadinfo.tfzq" size="mini" placeholder="请选择">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>洗头场所</el-divider>
                        <el-radio-group v-model="custheadinfo.xfcs">
                            <el-radio :label="1">居家居多</el-radio>
                            <el-radio :label="2">发廊居多</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>喜欢的发型</el-divider>
                        <el-checkbox-group v-model="custheadinfo.likefxarray">
                            <el-checkbox label="长发"></el-checkbox>
                            <el-checkbox label="中发"></el-checkbox>
                            <el-checkbox label="短发"></el-checkbox>
                            <el-checkbox label="bob"></el-checkbox>
                            <el-checkbox label="卷发"></el-checkbox>
                            <el-checkbox label="颜色"></el-checkbox>
                            <el-checkbox label="多色"></el-checkbox>
                            <el-checkbox label="日系"></el-checkbox>
                            <el-checkbox label="沙宣式"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>不喜欢的发型</el-divider>
                        <el-checkbox-group v-model="custheadinfo.notfxarray">
                            <el-checkbox label="长发"></el-checkbox>
                            <el-checkbox label="中发"></el-checkbox>
                            <el-checkbox label="短发"></el-checkbox>
                            <el-checkbox label="bob"></el-checkbox>
                            <el-checkbox label="卷发"></el-checkbox>
                            <el-checkbox label="颜色"></el-checkbox>
                            <el-checkbox label="多色"></el-checkbox>
                            <el-checkbox label="日系"></el-checkbox>
                            <el-checkbox label="沙宣式"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>颈椎病</el-divider>
                        <el-radio-group v-model="custheadinfo.jzb">
                            <el-radio label="1">重度</el-radio>
                            <el-radio label="2">轻度</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>头部经络</el-divider>
                        <el-radio-group v-model="custheadinfo.tbjl">
                            <el-radio label="1">一般</el-radio>
                            <el-radio label="2">轻度</el-radio>
                            <el-radio label="3">严重</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>脑供血不足</el-divider>
                        <el-radio-group v-model="custheadinfo.lgxbz">
                            <el-radio label="1">是</el-radio>
                            <el-radio label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>有无得过脑梗</el-divider>
                        <el-radio-group v-model="custheadinfo.glg">
                            <el-radio label="1">是</el-radio>
                            <el-radio label="2">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>油脂分泌</el-divider>
                        <el-radio-group v-model="custheadinfo.yzfm">
                            <el-radio label="1">过油</el-radio>
                            <el-radio label="2">过干</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>毛囊萎缩</el-divider>
                        <el-radio-group v-model="custheadinfo.mlws">
                            <el-radio label="1">重度</el-radio>
                            <el-radio label="2">轻度</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>毛囊口油脂堵塞</el-divider>
                        <el-radio-group v-model="custheadinfo.mlkyzds">
                            <el-radio label="1">重度</el-radio>
                            <el-radio label="2">轻度</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>头皮敏感</el-divider>
                        <el-checkbox-group v-model="custheadinfo.tpmgarray">
                            <el-checkbox label="发红"></el-checkbox>
                            <el-checkbox label="痒"></el-checkbox>
                            <el-checkbox label="发白"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>头皮炎症</el-divider>
                        <el-checkbox-group v-model="custheadinfo.tpyzarray">
                            <el-checkbox label="丘疹"></el-checkbox>
                            <el-checkbox label="脓包"></el-checkbox>
                            <el-checkbox label="毛囊肿"></el-checkbox>
                            <el-checkbox label="暗疮"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>头皮屑</el-divider>
                        <el-checkbox-group v-model="custheadinfo.tpxarray">
                            <el-checkbox label="重度"></el-checkbox>
                            <el-checkbox label="轻度"></el-checkbox>
                            <el-checkbox label="头皮癣"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>头发健康状况</el-divider>
                        <el-checkbox-group v-model="custheadinfo.tfjkzkarray">
                            <el-checkbox label="干燥"></el-checkbox>
                            <el-checkbox label="断裂"></el-checkbox>
                            <el-checkbox label="干枯分叉"></el-checkbox>
                            <el-checkbox label="烫染损伤"></el-checkbox>
                            <el-checkbox label="白发"></el-checkbox>
                            <el-checkbox label="斑秃"></el-checkbox>
                            <el-checkbox label="脱发"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>神经健康状况</el-divider>
                        <el-checkbox-group v-model="custheadinfo.sjjkzkarray">
                            <el-checkbox label="头晕"></el-checkbox>
                            <el-checkbox label="失眠"></el-checkbox>
                            <el-checkbox label="乏力"></el-checkbox>
                            <el-checkbox label="恶心"></el-checkbox>
                            <el-checkbox label="偏头痛"></el-checkbox>
                            <el-checkbox label="烦躁不安"></el-checkbox>
                            <el-checkbox label="发脾气"></el-checkbox>
                            <el-checkbox label="易感冒"></el-checkbox>
                            <el-checkbox label="头皮紧绷"></el-checkbox>
                            <el-checkbox label="神经衰弱"></el-checkbox>
                            <el-checkbox label="腰痛"></el-checkbox>
                            <el-checkbox label="记忆力下降"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-divider>诊断</el-divider>
                        <el-checkbox-group v-model="custheadinfo.zdarray">
                            <el-checkbox label="头部亚健康"></el-checkbox>
                            <el-checkbox label="神经亚健康"></el-checkbox>
                            <el-checkbox label="经络亚健康"></el-checkbox>
                            <el-checkbox label="头皮亚健康"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="专家诊断">
                        <el-input type="textarea" placeholder="专家诊断" :autosize="{ minRows: 2, maxRows: 100}" v-model="custheadinfo.zjzd"></el-input>
                    </el-form-item>
                </el-form>
                <van-tabbar>
                    <van-button type="primary" color="#1989fa" size="large" @click="saveHeadInfo">保存</van-button>
                </van-tabbar>
            </el-tab-pane>
            <el-tab-pane label="销售">
                <el-tabs v-model="activexs" stretch @tab-click="activexsHandleClick">
                    <el-tab-pane label="销售习惯" name="first" class="pfzk">
                        <el-descriptions :column="1" border class="xsxj">
                            <el-descriptions-item label="年消费能力">
                                <el-radio-group v-model="hairSale.xfnl">
                                    <el-radio :label="1">(0-1)</el-radio>
                                    <el-radio :label="2">(1-3)</el-radio>
                                    <el-radio :label="3">(3-5)</el-radio>
                                    <el-radio :label="4">(5-10)</el-radio>
                                    <el-radio :label="5">(10-20)</el-radio>
                                    <el-radio :label="6">(20-30)</el-radio>
                                    <el-radio :label="7">(30-50)</el-radio>
                                    <el-radio :label="8">(50以上)</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="消费自主权">
                                <el-radio-group v-model="hairSale.xfzzq">
                                    <el-radio :label="1">自主</el-radio>
                                    <el-radio :label="2">不自主</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="消费习惯">
                                <el-radio-group v-model="hairSale.xfxg">
                                    <el-radio :label="1">爽快</el-radio>
                                    <el-radio :label="2">纠结</el-radio>
                                    <el-radio :label="3">贪小</el-radio>
                                    <el-radio :label="4">分期</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="消费性格">
                                <el-radio-group v-model="hairSale.zxfxg">
                                    <el-radio :label="3">冲动</el-radio>
                                    <el-radio :label="6">理智</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="在什么情况下比较容易销售">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="hairSale.qk"></el-input>
                            </el-descriptions-item>
                        </el-descriptions>
                        <van-tabbar>
                            <van-button type="primary" color="#1989fa" size="large" @click="saveHairSale">保存</van-button>
                        </van-tabbar>
                    </el-tab-pane>
                    <el-tab-pane label="销售日志" name="send" class="pfzk">
                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getCardTansactionhistoryHairByCardId">
                            <div v-for="(item,key) in hairSaleLogs" :key="key" style="margin-bottom: 20px;">
                                    <el-descriptions class="margin-top" direction="vertical"  :column="1" border  >
                                        <el-descriptions-item>
                                            <template slot="label">
                                                {{item.accountdate}}
                                            </template>
                                            <div v-for="(val,idx) in item.cardTransactionHistories" :key="idx">
                                                {{val.projectname}}<!--({{val.amount}})-->
                                            </div>
                                        </el-descriptions-item>
                                        <!--<el-descriptions-item>
                                            <template slot="label">
                                                为什么花这个钱
                                            </template>
                                            {{item.beautySaleLog.why}}
                                        </el-descriptions-item>-->
                                        <el-descriptions-item>
                                            <template slot="label">
                                                具体的方案，赠送等等
                                            </template>
                                            <el-input type="textarea" v-model="item.beautySaleLog.programme" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                        </el-descriptions-item>
                                        <!--<el-descriptions-item>
                                            <template slot="label">
                                                销售沟通细节记录
                                            </template>
                                            <el-input type="textarea" v-model="item.beautySaleLog.connected" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                        </el-descriptions-item>
                                        <el-descriptions-item>
                                            <template slot="label">
                                                销售时铺垫了什么项目
                                            </template>
                                            <el-input type="textarea" v-model="item.beautySaleLog.bedding" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                        </el-descriptions-item>-->
                                    </el-descriptions>    
                                    <van-button type="primary" color="#1989fa" size="large" @click="saveHairSaleLog(item)">保存</van-button>
                            </div>
                        </van-list>
                    </el-tab-pane>
                    <el-tab-pane label="疗程注意事项" name="three" class="pfzk">
                        <el-descriptions class="margin-top pfzk" :column="1" size="mini" direction="vertical"  border>
                            <el-descriptions-item :label="item.projectname" v-for="(item,key) in projectPoints" :key="key">
                                <el-form size="mini" @submit.native.prevent>
                                    <el-form-item label="操作注意事项">
                                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="item.details"></el-input>
                                    </el-form-item>
                                    <el-form-item label="为什么要购买">
                                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="item.whybuy"></el-input>
                                    </el-form-item>
                                    <el-form-item style="margin-top: 5px;">
                                        <van-button type="primary" color="#1989fa" size="large" @click="saveProjectPoints(item)">保存</van-button>
                                    </el-form-item>
                                </el-form>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="服务">
                <el-form class="pfzk" label-position="top">
                    <el-form-item label="是否接受回访">
                        <el-radio-group v-model="beautyServer.returnVisit">
                            <el-radio :label="1">接受</el-radio>
                            <el-radio :label="2">不接受</el-radio>
                          </el-radio-group>
                    </el-form-item>
                    <el-form-item label="当下客户的满意度">
                        <el-radio-group v-model="beautyServer.grade">
                            <el-radio :label="1">一般</el-radio>
                            <el-radio :label="2">满意</el-radio>
                            <el-radio :label="3">不满意</el-radio>
                            <el-radio :label="4">很满意</el-radio>
                          </el-radio-group>
                    </el-form-item>
                    <el-form-item label="目前有什么不满意的状态">
                        <el-input type="textarea" v-model="beautyServer.dissatisfied" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <el-form-item label="喜欢喝什么饮料">
                        <el-input type="textarea" v-model="beautyServer.drinks" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <el-form-item label="喜欢吃什么水果">
                        <el-input type="textarea" v-model="beautyServer.fruits" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <el-form-item label="喜欢吃什么食物">
                        <el-input type="textarea" v-model="beautyServer.food" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <el-form-item label="性格">
                        <el-input type="textarea" v-model="beautyServer.characters" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <el-form-item label="喜欢聊天的内容">
                        <el-input type="textarea" v-model="beautyServer.chat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <el-form-item label="不能聊什么">
                        <el-input type="textarea" v-model="beautyServer.nochat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <!--<el-form-item label="与客户的聊天记录">
                        <el-input type="textarea" v-model="beautyServer.chatlog" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>-->
                    <el-form-item label="客户讲的比较重要的话">
                        <el-input type="textarea" v-model="beautyServer.importantchat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>
                    <!--<el-form-item label="客情记录送什么时间送过什么">
                        <el-input type="textarea" v-model="beautyServer.givelog" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                    </el-form-item>-->
                </el-form>
                <van-tabbar>
                    <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyServer">保存</van-button>
                </van-tabbar>
            </el-tab-pane>
            <el-tab-pane label="消耗">
                <van-list v-model="loadinglog" :finished="finishedlog" finished-text="没有更多了" @load="getHairCardtransactionhistoryByCash">
                    <el-card class="box-card mycard" v-for="(item,key) in hairXfLog" :key="key" style="margin-bottom: 10px;">
                        <div slot="header" style="background-color: rgb(238, 241, 246)" >
                            {{$moment(item.accountdate).format('YYYY-MM-DD')}}
                          <div v-for="(val,index) in item.cardTransactionHistories" :key="index">
                              {{val.projectname}}({{val.amount}})
                          </div>
                        </div>
                        <el-form size="mini" @submit.native.prevent>
                            <!--<el-form-item label="提升满意度当天做了什么(讲米兰好，效果呈现，不满意处理)">
                                <el-input type="textarea" v-model="item.beautyXfLog.oparation" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>-->
                            <el-form-item label="服务日志">
                                <el-input type="textarea" v-model="item.beautyXfLog.chat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <el-form-item label="满意度" v-if="item.hairRepay!=null">
                                <el-tag v-if="item.hairRepay.evaluate==1">满意</el-tag><el-tag type="danger" v-else>不满意</el-tag>
                            </el-form-item>
                            <el-form-item label="回访结果" v-if="item.hairRepay&&item.hairRepay.content">
                                <span>{{item.hairRepay.content}}</span>
                            </el-form-item>
                            <!--<el-form-item label="消耗时铺垫了什么项目(进度)">
                                <el-input type="textarea" v-model="item.beautyXfLog.xhtarget" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>-->
                            <div style="margin-top: 5px;">
                                <van-button type="primary" color="#1989fa" size="large" @click="saveHairXfLog(item,0)" style="width: 60%;">保存</van-button>
                                <van-button type="primary" color="#1989fa" size="large" @click="saveHairXfLog(item,1)" style="width: 30%;float: right;">保存预约</van-button>
                            </div>
                        </el-form>
                    </el-card>
                </van-list>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loadinglog:false,
                finishedlog:false,
                hairXfLog:[],
                projectPoints:[],
                activexs:"first",
                hairSale:{
                    storeid:"",
                    cardid:"",
                    memberid:"",
                    friendname:"",
                    friendcardnumber:"",
                    xfnl:0,
                    xfzzq:0,
                    xfxg:0,
                    zxfxg:0,
                    qk:0,
                },
                hairSaleLogs:[],
                loading:false,
                finished:false,
                active:0,
                options:[
                        {
                            value: 1,
                            label: '1月'
                        },
                        {
                            value: 2,
                            label: '2月'
                        },
                        {
                            value: 3,
                            label: '3月'
                        },
                        {
                            value: 4,
                            label: '4月'
                        },
                        {
                            value: 5,
                            label: '5月'
                        },
                        {
                            value: 6,
                            label: '6月'
                        },
                        {
                            value: 7,
                            label: '7月'
                        },
                        {
                            value: 8,
                            label: '8月'
                        },
                        {
                            value: 9,
                            label: '9月'
                        },
                        {
                            value: 10,
                            label: '10月'
                        },
                        {
                            value: 11,
                            label: '11月'
                        },
                        {
                            value: 12,
                            label: '12月'
                        }
                    ],
                custheadinfo:{
                    notfx:"",
                    notfxarray:[],
                    tfjkzk:"",
                    tfjkzkarray:[],
                    jzb:0,
                    xfcs:0,
                    rfzq:0,
                    tfzq:0,
                    likefxarray:[],
                    likefx:"",
                    tbjl:0,
                    lgxbz:0,
                    glg:0,
                    yzfm:0,
                    mlws:0,
                    mlkyzds:0,
                    tpmgarray:[],
                    tpmg:"",
                    tpyzarray:[],
                    tpyz:"",
                    tpxarray:[],
                    tpx:"",
                    sjjkzkarray:[],
                    sjjkzk:"",
                    zdarray:[],
                    zd:"",
                },
                memberInfo:{},
                mldate:"",
                beautydate:"",
                cardCourses:[],
                cardid:"",
                memberid:"",
                isloadHeadInfo:false,
                storeid:localStorage.getItem("storeid"),
                curPage:0,
                isloadHairSale:false,
                isloadcardcourse:false,
                beautyServer:{},
                isloadserver:false,
                curPageNo:0,
            }
        },
        created: function () {
            this.cardid=this.$route.query.cardid;
            this.memberid=this.$route.query.memberid;
            this.getMinDate();
            this.getBeautyMinDate();
            this.getCardCourseByCardId();
            this.getMemberInfoById();
        },
        methods:{
            saveHairXfLog(item,type){
                if(!item.beautyXfLog.chat){
                    this.$message.error("请输入服务日志");
                    return;
                }
                let beautyXfLog=new Object();
                beautyXfLog.storeid=this.storeid;
                beautyXfLog.cardid=this.cardid;
                beautyXfLog.memberid=this.memberid;
                beautyXfLog.accountdate=item.accountdate;
                beautyXfLog.oparation=item.beautyXfLog.oparation;
                beautyXfLog.xhtarget=item.beautyXfLog.xhtarget;
                beautyXfLog.chat=item.beautyXfLog.chat;
                //beautyXfLog.nextdate=item.beautyXfLog.nextdate;
                let projectname="";
                for(let val of item.cardTransactionHistories){
                    if(projectname!=""){
                        projectname=projectname+","+val.projectname;
                    }
                    else{
                        projectname=val.projectname;
                    }
                }
                beautyXfLog.projectname=projectname;
                this.$postw("hairmanager/saveHairXfLog",beautyXfLog).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        if(type==1){
                            this.$router.push({path:"/addhairorder",query:{
                                cardid:this.cardid,
                                cardnumber:this.cardnumber,
                                memberid:this.memberid,
                                membername:this.membername,
                                memberphone:this.memberphone,
                                cardtypeid:this.cardtypeid,
                                sex:this.sex
                            }});
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getHairCardtransactionhistoryByCash(){
                this.curPageNo++;
                this.loadinglog=true;
                this.$post("hairmanager/getHairCardtransactionhistoryByCash",{storeid:this.storeid,cardid:this.cardid,curPage:this.curPageNo}).then(res=>{
                    this.loadinglog=false;
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.hairXfLog.push(val);
                            }
                        }
                        else{
                            this.finishedlog=true;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveBeautyServer(){
                this.beautyServer.storeid=this.storeid;
                this.beautyServer.memberid=this.memberid;
                this.beautyServer.cardid=this.cardid;
                this.$postw("beautymanager/saveBeautyServer",this.beautyServer).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyServerById(){
                this.$post("beautymanager/getBeautyServerById",{storeid:this.storeid,memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        this.beautyServer=res.object;
                        if(this.beautyServer==null){
                            this.beautyServer={};
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveProjectPoints(item){
                item.storeid=this.storeid;
                item.cardid=this.cardid;
                item.memberid=this.memberid;
                this.$postw("beautymanager/saveProjectPoints",item).then(res=>{
                    if(res.sucess){
                        this.$message({message: '保存成功',type: 'success'});
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getHairProjectPointsById(){
                this.$post("hairmanager/getHairProjectPointsById",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.projectPoints=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveHairSale(){
                this.hairSale.storeid=this.storeid;
                this.hairSale.cardid=this.cardid;
                this.hairSale.memberid=this.memberid;
                this.$postw("hairmanager/saveHairSale",this.hairSale).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message:"保存成功",
                            type:"success"
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            activexsHandleClick(){
                if(this.activexs=="send"){
                    this.curPage=0;
                    this.loading=true;
                    this.finished=false;
                    this.hairSaleLogs=[];
                    this.getCardTansactionhistoryHairByCardId();
                }
                else if(this.activexs=="three"){
                    if(this.isloadcardcourse==false){
                        this.getHairProjectPointsById();
                        this.isloadcardcourse=true;
                    }
                }
            },
            getHairSale(){
                this.$post("hairmanager/getHairSale",{storeid:this.storeid,memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        if(res.object==null){
                            return;
                        }
                        this.hairSale=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveHairSaleLog(item){
                if(!item.beautySaleLog.programme){
                    this.$message({message:"具体的方案，赠送等等",type:"error"});
                    return;
                }
                let log=new Object();
                log.storeid=this.storeid;
                log.cardid=this.cardid;
                log.memberid=this.memberid;
                log.projectname="";
                log.accountdate=item.accountdate;
                for(let val of item.cardTransactionHistories){
                    if(log.projectname){
                        log.projectname=log.projectname+","+val.projectname;
                    }
                    else{
                        log.projectname=val.projectname;
                    }
                }
                log.why=item.beautySaleLog.why;
                log.programme=item.beautySaleLog.programme;
                log.connected=item.beautySaleLog.connected;
                log.bedding=item.beautySaleLog.bedding;
                log.uncultivated=item.beautySaleLog.uncultivated;
                this.$postw("hairmanager/saveHairSaleLog",log).then(res=>{
                    if(res.sucess){
                        this.$message({message:"保存成功",type:"success"});
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardTansactionhistoryHairByCardId(){
                this.curPage++;
                this.loading=true;
                this.$post("hairmanager/getCardTansactionhistoryHairByCardId",{storeid:this.storeid,cardid:this.cardid,curPage:this.curPage}).then(res=>{
                    this.loading=false;
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.hairSaleLogs.push(val);
                            }
                        }
                        else{
                            this.finished=true;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            handleClick(){
                if(this.active==1){
                    if(this.isloadHeadInfo==false){
                        this.getCustHeadInfoByMemberId();
                        this.isloadHeadInfo=true;
                    }
                }
                else if(this.active==2){
                    if(this.isloadHairSale==false){
                        this.getHairSale();
                        this.isloadHairSale=true;
                    }
                }
                else if(this.active==3){
                    if(this.isloadserver==false){
                        this.getBeautyServerById();
                        this.isloadserver=true;
                    }
                }
                else if(this.active==4){
                    this.loadinglog=false;
                    this.finishedlog=false;
                    this.curPageNo=0;
                    this.hairXfLog=[];
                    this.getHairCardtransactionhistoryByCash();
                }
            },
            getCustHeadInfoByMemberId(){
                this.$post("ddstaff/getCustHeadInfoByMemberId",{memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        if(res.object==null){
                            return;
                        }
                        let obj=res.object;
                        this.custheadinfo.jzb=obj.jzb;
                        this.custheadinfo.xfcs=obj.xfcs;
                        this.custheadinfo.rfzq=obj.rfzq;
                        this.custheadinfo.tfzq=obj.tfzq;
                        this.custheadinfo.tbjl=obj.tbjl;
                        this.custheadinfo.lgxbz=obj.lgxbz;
                        this.custheadinfo.glg=obj.glg;
                        this.custheadinfo.yzfm=obj.yzfm;
                        this.custheadinfo.mlws=obj.mlws;
                        this.custheadinfo.mlkyzds=obj.mlkyzds;
                        this.custheadinfo.zjzd=obj.zjzd;
                        if(obj.notfx!=null){
                            this.custheadinfo.notfxarray=obj.notfx.split(",");
                        }
                        if(obj.likefx!=null){
                            this.custheadinfo.likefxarray=obj.likefx.split(",");
                        }
                        if(obj.tpmg){
                            this.custheadinfo.tpmgarray=obj.tpmg.split(",");
                        }
                        if(obj.tpyz){
                            this.custheadinfo.tpyzarray=obj.tpyz.split(",");
                        }
                        if(obj.sjjkzk){
                            this.custheadinfo.sjjkzkarray=obj.sjjkzk.split(",");
                        }
                        if(obj.zd){
                            this.custheadinfo.zdarray=obj.zd.split(",");
                        }
                        if(obj.tfjkzk){
                            this.custheadinfo.tfjkzkarray=obj.tfjkzk.split(",");
                        }
                        if(obj.tpx){
                            this.custheadinfo.tpxarray=obj.tpx.split(",");
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveHeadInfo(){
                if(this.custheadinfo.likefxarray!=null && this.custheadinfo.likefxarray.length>0){
                    this.custheadinfo.likefx=this.custheadinfo.likefxarray.join(",");
                }

                if(this.custheadinfo.tpmgarray!=null && this.custheadinfo.tpmgarray.length>0){
                    this.custheadinfo.tpmg=this.custheadinfo.tpmgarray.join(",");
                }

                if(this.custheadinfo.tpyzarray!=null && this.custheadinfo.tpyzarray.length>0){
                    this.custheadinfo.tpyz=this.custheadinfo.tpyzarray.join(",");
                }

                if(this.custheadinfo.sjjkzkarray!=null && this.custheadinfo.sjjkzkarray.length>0){
                    this.custheadinfo.sjjkzk=this.custheadinfo.sjjkzkarray.join(",");
                }

                if(this.custheadinfo.zdarray!=null && this.custheadinfo.zdarray.length>0){
                    this.custheadinfo.zd=this.custheadinfo.zdarray.join(",");
                }

                if(this.custheadinfo.tfjkzkarray!=null && this.custheadinfo.tfjkzkarray.length>0){
                    this.custheadinfo.tfjkzk=this.custheadinfo.tfjkzkarray.join(",");
                }

                if(this.custheadinfo.notfxarray!=null && this.custheadinfo.notfxarray.length>0){
                    this.custheadinfo.notfx=this.custheadinfo.notfxarray.join(",");
                }
                if(this.custheadinfo.tpxarray!=null && this.custheadinfo.tpxarray.length>0){
                    this.custheadinfo.tpx=this.custheadinfo.tpxarray.join(",");
                }


                this.custheadinfo.cardid=this.cardid;
                this.custheadinfo.memberid=this.memberid;
                this.custheadinfo.createtor=localStorage.getItem("staffid"),
                this.custheadinfo.createname=localStorage.getItem("staffname");
                this.custheadinfo.storeid=localStorage.getItem("storeid");

                this.$postw("ddstaff/addCustHeadInfo",this.custheadinfo).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message:"保存成功",
                            type:"success"
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            updateMemberInfo(){
                this.$postw("cardinfo/updateMemberInfo",this.memberInfo).then(res=>{
                    if(res.sucess){
                        this.$message({message:"修改成功",type:"success"});
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getMemberInfoById(){
                this.$post("cardinfo/getMemberInfoById",{memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        this.memberInfo=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardCourseByCardId(){
                this.$post("cardinfo/getCardCourseByCardId",{cardid:this.cardid,showRest:0}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                if(val.projectbigtype!=2){
                                    this.cardCourses.push(val);
                                }
                            }
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getMinDate(){
                this.$post("beautymanager/getMinDate",{cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.mldate=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyMinDate(){
                this.$post("beautymanager/getBeautyMinDate",{cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.beautydate=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss">
    .pfzk .el-form-item{
        margin-bottom:0px;
    }

    .pfzk .el-divider--horizontal{
        margin:12px 0px;
    }

    .pfzk{
        margin-bottom: 45px;
    }
</style>


// WEBPACK FOOTER //
// src/page/manager/hairmemberinfo.vue